import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-shared-react/pkg/redux/flags/hooks';
import VisuallyHidden from '@wix/da-shared-react/pkg/a11y/VisuallyHidden';
import PageContainer from '../PageContainer';
import { FacetStreamChildrenProps, FacetStreamProps } from '../FacetStream';
import { BiLoggerContextProvider } from '@wix/da-shared-react/pkg/biLogger';
import { MobileContext } from '@wix/da-shared-react/pkg/Context';
import DateNavigationRow from '../DateNavigationRow';
import ContentLoader from '../ContentLoader';
import DailyDeviationGrid from '../DailyDeviationGrid';
import s from './DailyDeviationPage.scss';

export interface Props extends FacetStreamProps {
  date?: string;
}

export const DailyDeviationPage: React.FC<Props & FacetStreamChildrenProps> = ({
  date,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const shouldRenderH1 = useFlag('proposed_h1s');

  return (
    <>
      {shouldRenderH1 && (
        <VisuallyHidden>
          <h1>{t('dailyDev.heading')}</h1>
        </VisuallyHidden>
      )}
      <PageContainer className={s['root']} withTabHeader>
        <BiLoggerContextProvider
          value={{
            sectionname: 'general',
          }}
        >
          <ContentLoader>
            <DateNavigationRow isMobile={isMobile} date={date} />
            <div className={s['deviations']}>
              <DailyDeviationGrid />
            </div>
          </ContentLoader>
        </BiLoggerContextProvider>
      </PageContainer>
    </>
  );
};
DailyDeviationPage.displayName = 'DailyDeviationPage';

export default DailyDeviationPage;
